<template>
    <Modal >
        <div class="container">
            <div class="text">
                {{$t('outils.compteur.step.three.informations.modal')}}
            </div>
            <img class="close-icon" @click="cancel" :src="closeIcon" alt="close" />
        </div>
    </Modal>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import Modal from '@/components/ui-components/Modal.vue';

export default defineComponent({
    components: { Modal, },
    computed: {
        closeIcon() {
            return require('@/assets/img/close-black.svg');
        },
    },
    methods: {
        cancel(){
            this.$emit('cancel');
        }
    },
});
</script>

<style scoped>
.container{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 450px;
    background-color: var(--white);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14),
    0 1px 5px rgba(0, 0, 0, 0.12);
    text-align: center;
    font-weight: 500;
    font-size: var(--font-size-low-medium);
    color: var(--color-principal);
    padding: 16px;
    gap: 8px;
}
.close-icon {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
}
.text {
    margin: 25px;
}
</style>
